// Who is on the clock right now.
//
// Backed by the on_the_clock() function (20260902110000), not by a query
// against time_entries: that table's RLS deliberately shows a colleague nothing
// of anyone else's clock, because it carries every hour they have ever logged.
// The function returns presence and only presence.
import { supabase } from './supabase';

export type OnTheClock = {
  profile_id: string;
  full_name: string | null;
  /** 'in' = working, 'break' = paused. There is no third state: checking out
   *  removes the row entirely. */
  state: 'in' | 'break';
  since: string;
};

export async function listOnTheClock(): Promise<OnTheClock[]> {
  if (!supabase) return [];
  const { data, error } = await supabase.rpc('on_the_clock');
  // A caller without talent:view or people:view gets an empty set, not an
  // error — the function filters rather than raising, so an unauthorised
  // viewer simply sees nobody.
  if (error) return [];
  return (data as OnTheClock[]) ?? [];
}

/** "2h 14m" — how long they have been on the clock. */
export const sinceLabel = (since: string, nowMs: number = Date.now()): string => {
  const mins = Math.max(0, Math.floor((nowMs - new Date(since).getTime()) / 60000));
  const h = Math.floor(mins / 60);
  return h ? `${h}h ${mins % 60}m` : `${mins}m`;
};
